import { DONATION_RECURRENCES, DonationFrequency } from "./donationRecurrence";

type TrackedAmount = { amount?: number | null; recurrenceInterval: string };

export type SuggestedAmountsTracking = {
  suggested_amounts_count: number;
  frequencies_offered: DonationFrequency[];
};

export type DonationAmountSource = "preselected" | "tile" | "custom";

export const getSuggestedAmountsTracking = (amounts: TrackedAmount[] | null | undefined): SuggestedAmountsTracking => {
  const offeredRecurrences = DONATION_RECURRENCES.filter(({ frequency }) =>
    (amounts ?? []).some((amount) => amount.recurrenceInterval === frequency)
  );
  return {
    suggested_amounts_count: Math.max(
      0,
      ...offeredRecurrences.map(
        ({ frequency }) =>
          (amounts ?? []).filter((amount) => amount.recurrenceInterval === frequency && (amount.amount ?? 0) > 0).length
      )
    ),
    frequencies_offered: offeredRecurrences.map(({ frequency }) => frequency),
  };
};

export const getDonationAmountSource = ({
  hasChangedDonationAmount,
  lastInteractionWasClickedAmount,
}: {
  hasChangedDonationAmount: boolean;
  lastInteractionWasClickedAmount: boolean;
}): DonationAmountSource => {
  if (!hasChangedDonationAmount) {
    return "preselected";
  }
  return lastInteractionWasClickedAmount ? "tile" : "custom";
};
